module.exports = __webpack_public_path__ + "media/images/sp-side-ad@3x-a5a4a32b79371f45d809d498b766244f.png";